import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

/**
 * Auth store global — persiste el token en localStorage.
 *
 * Diseñado para convivir con los 3 `token_type` que devuelve `/auth/login`:
 *   - "access"                    — token de acceso normal (API usable)
 *   - "password_change_required"  — token corto, solo sirve para /auth/change-password
 *   - "tfa_challenge"             — pendiente 2FA (no implementado en F11.1)
 */

export type User = {
  id: string;
  email: string;
  nombre_completo: string | null;
  rol: { id: string; nombre: string } | null;
};

type AuthState = {
  accessToken: string | null;
  changeToken: string | null;
  user: User | null;
  permissions: string[];  // F84/F85: permisos efectivos (rol + overrides)
  // Setters
  setAccessToken: (token: string) => void;
  setChangeToken: (token: string) => void;
  setUser: (user: User) => void;
  setPermissions: (perms: string[]) => void;
  logout: () => void;
  // Helper: ¿el user tiene este permiso?
  hasPermission: (codigo: string) => boolean;
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      accessToken: null,
      changeToken: null,
      user: null,
      permissions: [],
      setAccessToken: (token) => set({ accessToken: token, changeToken: null }),
      setChangeToken: (token) => set({ changeToken: token, accessToken: null }),
      setUser: (user) => set({ user }),
      setPermissions: (perms) => set({ permissions: perms }),
      logout: () => set({
        accessToken: null, changeToken: null, user: null, permissions: [],
      }),
      hasPermission: (codigo) => get().permissions.includes(codigo),
    }),
    {
      name: "byteisp.auth",
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({
        accessToken: s.accessToken,
        user: s.user,
        permissions: s.permissions,
      }),
    }
  )
);
